import React from 'react';
import {
  Avatar as MuiAvatar,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    extraSmall: {
      width: '28px',
      height: '28px',
      fontSize: '11px',
      backgroundColor: '#E8F4F0',
      color: '#003F2D',
      fontWeight: 600,
      border: '1px solid #CCE5DD',
    },
    small: {
      width: '40px',
      height: '40px',
      fontSize: '14px',
      backgroundColor: '#E8F4F0',
      color: '#003F2D',
      fontWeight: 600,
      border: '1px solid #CCE5DD',
    },
    medium: {
      width: '48px',
      height: '48px',
      fontSize: '16px',
      backgroundColor: '#E8F4F0',
      color: '#003F2D',
      fontWeight: 600,
      border: '1px solid #CCE5DD',
    },
    large: {
      width: '56px',
      height: '56px',
      fontSize: '18px',
      backgroundColor: '#E8F4F0',
      color: '#003F2D',
      fontWeight: 600,
      border: '1px solid #CCE5DD',
    },
    disabled: {
      opacity: 0.5,
    },
  }),
);

export interface AvatarProps {
  initials: string;
  size?: 'extra-small' | 'small' | 'medium' | 'large';
  disabled?: boolean;
  className?: string;
}

export const Avatar: React.FC<AvatarProps> = ({
  initials,
  size = 'extra-small',
  disabled = false,
  className = '',
}) => {
  const classes = useStyles();
  const sizeClass = size === 'extra-small' ? classes.extraSmall : classes[size];
  
  return (
    <MuiAvatar
      className={`${sizeClass} ${disabled ? classes.disabled : ''} ${className}`}
    >
      {initials}
    </MuiAvatar>
  );
};
